import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { saveAs } from 'file-saver';
import { getTemplate } from '../../../../http/http-calls.js';
import { toast } from 'react-toastify';

const TemplateDownload = ({ el }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      // const response = await getTemplate(el._id);
      const blob = new Blob([JSON.stringify(el, null, 2)], {
        type: 'application/json',
      });
      saveAs(blob, `${el.name}.json`);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(`Error downloading template: ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  return (
    <Button
      style={{
        background: "none", border: "2px solid gray", color: "white"
      }}
      className='downloadBtn download-json-template'
      disabled={isLoading}
      onClick={handleDownload}
    >
      {isLoading ? 'Downloading...' : 'Download'}
    </Button >
  );
};

export default TemplateDownload;
